<template>
  <div class="tr-step-3">
    <div class="step3C__highlight-card">
      <div class="highlight-header">HIGHLIGHTS</div>
      <Highlights3C />
    </div>
    <div class="tr-step-3__card">
      <div class="tr-step-3C__mainHead">STEP:3 Openable Area Details</div>
      <div class="tr-step-3C__subHead">(C) Openable Area Ventilator & Door</div>

      <div>
        <v-expansion-panels focusable>
          <v-expansion-panel v-for="(item, i) in Steps3C" :key="i" :style="{ margin: '4px' }">
            <v-expansion-panel-header>
              <div class="accordian__header--3C">
                <v-icon left>{{ item.icon }}</v-icon>

                {{ item.name }}
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="step-3C__accordian-fields-wrap">
                <div class="step-3C__accordian-fields-row">
                  <!--Wall Surface Area Table -->
                  <div v-if="item.name === 'Openable area ventilator'">
                    <VentilatorOpenableAreaTable3C />
                  </div>
                  <div v-else-if="item.name === 'Openable area door'">
                    <DoorOpenableAreaTable3C />
                  </div>
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
      <div class="step-3C__next-back-row">
        <v-btn color="blue-grey" class="ma-2 white--text" @click="$router.push({ name: 'Step3B' })"><v-icon left> mdi-arrow-left </v-icon> Back </v-btn>
        <v-btn color="blue-grey" class="ma-2 white--text" @click="$router.push({ name: 'Step4' })">Next <v-icon right> mdi-arrow-right </v-icon> </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import VentilatorOpenableAreaTable3C from '../tables/step3C/VentilatorOpenableAreaTable3C.vue';
import DoorOpenableAreaTable3C from '../tables/step3C/DoorOpenableAreaTable3C.vue';
import Highlights3C from '../highlights/Highlights3C.vue';
export default {
  components: {
    VentilatorOpenableAreaTable3C,
    DoorOpenableAreaTable3C,
    Highlights3C,
  },
  computed: {
    schema: {
      get: function() {
        return this.$store.state.schema;
      },
      set: function(newSchema) {
        this.$store.dispatch('setSchema', newSchema);
      },
    },

    step2: {
      get: function() {
        return this.$store.state.schema.inputs.step2;
      },
      set: function(step2) {
        this.$store.dispatch('setStep2', step2);
      },
    },
    step3B: {
      get: function() {
        return this.$store.state.schema.inputs.step3B;
      },
      set: function(step3B) {
        this.$store.dispatch('setStep3B', step3B);
      },
    },
    step3C: {
      get: function() {
        return this.$store.state.schema.inputs.step3C;
      },
      set: function(step3C) {
        this.$store.dispatch('setStep3C', step3C);
      },
    },
    step4: {
      get: function() {
        return this.$store.state.schema.inputs.step4;
      },
      set: function(step4) {
        this.$store.dispatch('setStep4', step4);
      },
    },
  },
  data() {
    return {
      Steps3C: [
        { name: 'Openable area ventilator', icon: 'mdi-hvac' },
        { name: 'Openable area door', icon: 'mdi-door' },
      ],
    };
  },
  beforeUpdate() {
    // wfrop
    this.calculateTotalOpenableArea();
    this.totalCarpetArea();
    this.wfropCalculation();
    // vlt
    this.requiredVlt();
  },
  // watch: {
  //   schema: {
  //     handler: function() {
  //       // wfrop
  //       this.calculateTotalOpenableArea();
  //       this.totalCarpetArea();
  //       this.wfropCalculation();
  //       // vlt
  //       this.requiredVlt();
  //     },
  //     immediate: true,
  //     deep: true,
  //   },
  // },
  methods: {
    calculateTotalOpenableArea() {
      this.step4.wfropObj.total_openable_area = 0;
      this.step4.wfropObj.total_openable_area = (+this.step3B.summary_window_openable.total_openable_area + +this.step3C.summary_ventilator_openable.total_openable_area).toFixed(2);
    },
    totalCarpetArea() {
      let calcCarpetArea = 0;
      let finalCarpetArea = 0;
      for (let i = 0; i <= this.step2.houseTypeArrObj.length - 1; i++) {
        calcCarpetArea = calcCarpetArea + this.step2.houseTypeArrObj[i].carpet_area * this.step2.houseTypeArrObj[i].no_of_du;
      }
      finalCarpetArea = calcCarpetArea * this.step2.commonFields.no_of_floors;
      this.step4.wfropObj.total_carpet_area = finalCarpetArea.toFixed(2);
    },
    wfropCalculation() {
      this.step4.wfropObj.wfropPercent = +((this.step4.wfropObj.total_openable_area / this.step4.wfropObj.total_carpet_area) * 100).toFixed(2);
    },

    //--------------------- VLT Methods-------------
    // calcWindowToWallRatio() {
    //   this.step4.vltObj.window_wall_ratio = ((+this.step3C.summary_ventilator_openable.total_glass_area + +this.step3B.summary_window_glass.total_glass_area) / +this.schema.inputs.step3A.summary.total_wall_surface_area).toFixed(2);
    // },
    requiredVlt() {
      this.minRange = 0.0;
      this.maxRange = 0;
      if (this.step4.vltObj.window_wall_ratio <= 0.3) {
        this.step4.vltObj.required_vlt = 0.27;
        this.minRange = 0.0;
        this.maxRange = 0.3;
        return 0.27;
      } else if (this.step4.vltObj.window_wall_ratio >= 0.31 && this.step4.vltObj.window_wall_ratio <= 0.4) {
        this.step4.vltObj.required_vlt = 0.2;
        this.minRange = 0.31;
        this.maxRange = 0.4;
        return 0.2;
      } else if (this.step4.vltObj.window_wall_ratio >= 0.41 && this.step4.vltObj.window_wall_ratio <= 0.5) {
        this.step4.vltObj.required_vlt = 0.16;
        this.minRange = 0.41;
        this.maxRange = 0.5;
        return 0.16;
      } else if (this.step4.vltObj.window_wall_ratio >= 0.51 && this.step4.vltObj.window_wall_ratio <= 0.6) {
        this.step4.vltObj.required_vlt = 0.13;
        this.minRange = 0.51;
        this.maxRange = 0.6;
        return 0.13;
      } else if (this.step4.vltObj.window_wall_ratio >= 0.61 && this.step4.vltObj.window_wall_ratio <= 0.7) {
        this.step4.vltObj.required_vlt = 0.11;
        this.minRange = 0.61;
        this.maxRange = 0.7;
        return 0.11;
      }
    },
  },
};
</script>

<style lang="scss">
.tr-step-3 {
  padding: 32px;
  width: 100%;
  height: 100%;
}
.step3C__highlight-card {
  background-color: #fff;
  margin: 24px 0px;
  // padding: 38px;
  .highlight-header {
    background-color: #5a6978;

    padding: 8px 24px;
    color: #fff;
    font-size: 20px;
  }
}
.tr-step-3__card {
  background-color: #fff;
  padding: 38px;
  // width: 80%;
}
.tr-step-3C__mainHead {
  margin: 0px 0px 8px 0;
  font-size: 28px;
  color: #343f4b;
  text-align: center;
}
.accordian__header--3C {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.tr-step-3C__subHead {
  margin: 0px 0px 18px 0;
  font-size: 20px;
  color: #343f4b;
  text-align: center;
}
.step-3C__summary {
  margin-top: 12px;
  .summary-head {
    font-size: 18px;
    color: #343f4b;
    font-weight: 800;
  }
}
.summary-block__wrap {
  display: flex;
  flex-direction: column;
  .summary-field__row {
    display: flex;
    justify-content: space-between;
  }
  .summary-field__label {
    font-size: 12px;
    color: #343f4b;
  }
}
.step-3C__next-back-row {
  display: flex;
  justify-content: space-between;
}
</style>
